export const brandName = 'Linkfluencer'
export const brandUrl = 'https://linkfluencer.appforgelabs.com'
export const contactEmail = 'hello@appforgelabs.com'
export const supportEmail = 'support@appforgelabs.com'
export const socialMedia = {
  twitter: 'https://x.com/LuisMartinezSu2'
}